module.exports = __webpack_public_path__ + "static/media/phone_green_WEB_CHANGE_7.f4a73e22.png";